<template>
  <v-dialog
    width="650px"
    class="reject-dialog"
    title="Attention"
    :visible.sync="rejectDialogVisible"
    :scrollbar="false"
    :before-close="beforeClose"
    @closed="onClosed"
    @open="onOpen"
  >
    <div class="form-wrap">
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        label-position="top"
        :rules="rejectDialogRules"
        style="padding-top: 0px;padding-bottom: 0px;"
      >
        <div class="content">
          <el-form-item
            label="Select Reject Reason"
            prop="mainRejectReason"
            class="remark-input"
            label-position="left"
          >
            <el-select
            style="width: 260px"
              v-model="rejectForm.mainRejectReason"
              placeholder="Please select"
               @change="mainRejectReasonChange"
            >
            <el-option v-for="(item, index) in mainRejectReasonOptions" :key="index" :label="item.reason" :value="item.reason">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item
            label="You will reject the meeting request, please fill in the rejection information, thank you"
            prop="remark"
            class="remark-input"
          >
            <el-input
              v-model="rejectForm.remark"
              style="text-align: top"
              :autosize="{ minRows: 7 }"
              type="textarea"
              maxlength="200"
              show-word-limit
              placeholder="Please fill in the comments"
            />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit"> Reject </el-button>
      <el-button plain @click="onClosed"> Cancel </el-button>
    </div>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { trimValidate } from "../../utils/validator";
export default {
  name: "reject-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    return {
//       非礼来产品及治疗领域：您咨询的问题非礼来产品及治疗领域
// 非医学科学问询：您咨询的问题非医学科学问询
// 涉及临床决策或个体化患者诊疗建议：您咨询的问题涉及临床决策或个体化患者诊疗建议
      mainRejectReasonOptions: [
        {
          reason: "非礼来产品及治疗领域",
        },
        {
          reason: "非医学科学问询",
        },
        {
          reason: "涉及临床决策或个体化患者诊疗建议",
        },
      ],
      rejectDialogVisible: this.visible,
      rejectForm: {
        requestId: "",
        remark: "",
        mainRejectReason: null,
      },
      rejectDialogRules: {
        mainRejectReason: [
          {
            required: true,
            validator: trimValidate("Please select reject reason"),
            trigger: "change",
          },
        ],
      },
      forwardStatus: "",
    };
  },
  watch: {
    visible(value) {
      this.rejectDialogVisible = value;
    },
  },
  methods: {
    mainRejectReasonChange(value) {
      if (value === "非礼来产品及治疗领域") {
        this.rejectForm.remark = "您咨询的问题非礼来产品及治疗领域，暂时无法提供RTMS服务，感谢您的理解与支持。";
      } else if (value === "非医学科学问询") {
        this.rejectForm.remark = "您咨询的问题非医学科学问询，暂时无法提供RTMS服务，感谢您的理解与支持。";
      } else if (value === "涉及临床决策或个体化患者诊疗建议") {
        this.rejectForm.remark = "您咨询的问题涉及临床决策或个体化患者诊疗建议，暂时无法提供RTMS服务，感谢您的理解与支持。";
      } else {
        this.rejectForm.remark = "";
      }
    },
    beforeClose(done) {
      this.$refs.rejectForm.resetFields();
      done();
    },
    onClosed() {
      this.$emit("update:visible", false);
      this.$emit("data", null);
      this.$refs.rejectForm.resetFields();
    },
    onOpen() {
      if (this.data) {
        this.rejectForm.requestId = this.data.Id;
        // this.rejectForm.remark =
        //   "您咨询的问题超出了礼来产品及相关治疗领域的范围";
        Object.assign(this.rejectForm, this.data);
      }
    },
    handleSubmit() {
      this.$refs.rejectForm.validate((valid) => {
        if (valid) {
          this.$confirm(
            "Please make sure if it is ready to reject?",
            "Attention",
            { confirmButtonText: "Confirm", cancelButtonText: "Cancel" }
          ).then(() => {
            this.axios
              .post("/meetingReq/reject", {
                reqId: this.rejectForm.requestId,
                rejectReason: this.rejectForm.remark,
                mainRejectReason: this.rejectForm.mainRejectReason,
                modifyDt: moment().format("YYYY-MM-DD HH:mm:ss"),
                modifyBy: localStorage.getItem("userId"),
              })
              .then((res) => {
                if (res.code == 200) {
                  this.$message({
                    type: "success",
                    message: "Reject meeting request successfully",
                  });
                  this.$emit("update:visible", false);
                  this.$emit("success");
                } else {
                  this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.$message({
                  type: "info",
                  message: "error: " + err,
                });
              });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.reject-dialog {
  min-width: 650px;
  .el-scrollbar.dialog {
    max-height: 100%;
    width: 650px;
    min-width: 650px;
  }
  .el-dialog__header {
    padding: 15px;
    text-align: left;
    .el-dialog__title {
      color: black;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__footer {
    padding: 10px 15px 15px;
  }
  .form-wrap {
    // height: 220p/x;
    .el-scrollbar {
      text-align: left;
      height: 100%;
      .el-scrollbar__wrap {
        overflow-x: hidden;
        text-align: left;
      }
    }
    .el-form {
      padding: 30px 20px;
      .el-form-item {
        margin-bottom: 15px;
        .el-form-item__label {
          padding: 0;
        }
      }
      h3 + p {
        margin-top: 5px;
        font-size: 14px;
      }
      .el-row:last-child {
        margin-top: 10px;
      }
      .el-select {
        width: 100%;
      }
      .remark-input {
        .el-input--small .el-input__inner {
          height: 80px;
          line-height: 32px;
        }
      }
    }
  }
  .dialog-footer {
    text-align: center;
  }
}
</style>
